/**
 * Dms备注管理接口
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//备注列表
export function getList(param) {
  /**
   *  {
        relatedTableType //上传文件类型（1-渠道；2-渠道联系人；3-门店；4-门店店员）
        relatedTableId //对应操作Id 渠道ID、门店ID、联系人ID、员工ID
        p,
        s
       }
   */
  return request(`${config.server}/api/v1/dms/remark/list`, {
    method: 'post',
    body: param,
  });
}
//备注新增
export function add(param) {
  /**
   *  {
        relatedTableType //上传文件类型（1-渠道；2-渠道联系人；3-门店；4-门店店员）
        relatedTableId //对应操作Id 渠道ID、门店ID、联系人ID、员工ID
        content //文本
       }
   */
  return request(`${config.server}/api/v1/dms/remark/save`, {
    method: 'post',
    body: param
  });
}
//修改备注
export function update(param) { //附件id
  return request(`${config.server}/api/v1/dms/remark/update`, {
    method: 'post',
    body: param,
  });
}
//备注删除
export function deleteRemarks(param) {
  return request(`${config.server}/api/v1/dms/remark/delete`, {
    method: 'post',
    body: param,
  });
}


// WEBPACK FOOTER //
// ./src/service/remark/remark.js